import { render, staticRenderFns } from "./overview-notifications.vue?vue&type=template&id=2737d378&scoped=true&"
import script from "./overview-notifications.vue?vue&type=script&lang=js&"
export * from "./overview-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2737d378",
  null
  
)

export default component.exports